import {
  Autosuggest,
  Box,
  Button,
  ColumnLayout,
  DatePicker,
  ExpandableSection,
  FileInput,
  Input,
  Modal,
  Select,
  SelectProps,
  SpaceBetween,
  Spinner,
  Textarea,
} from '@cloudscape-design/components';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import {
  Container,
  Header,
  AppLayout,
  ContentLayout,
  Grid,
  Toggle,
  Form,
  Alert,
  FormField,
  StatusIndicator,
} from '@cloudscape-design/components';
import { ErrorMessage } from './ErrorMessage';
import { uploadDripContactsExcel } from '../common/api/dripContacts';
import { TaskCreateResponse } from '../common/types';

export type DripContactUploadModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onComplete?: (data: TaskCreateResponse) => void;
};

export function DripContactUploadModal(props: DripContactUploadModalProps) {
  const { open, setOpen, onComplete } = props;

  const [file, setFile] = useState<File | null>(null);

  const close = () => {
    setFile(null);
    setOpen(false);
  };

  const isInvalid = !file;

  const upload = useMutation({
    mutationFn: uploadDripContactsExcel,
    onSuccess: (data) => {
      if (onComplete && data) {
        onComplete(data);
      }
      close();
    },
  });

  const handleCreate = () => {
    if (upload.isPending) {
      return;
    }
    if (isInvalid) {
      return;
    }

    upload.mutate(file);
  };

  return (
    <Modal
      size="medium"
      onDismiss={close}
      visible={open}
      closeAriaLabel="Close"
      header="Upload drip contacts"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={close}>
              Cancel
            </Button>
            <Button
              loading={upload.isPending}
              variant="primary"
              onClick={handleCreate}
              disabled={isInvalid}
            >
              Upload
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="m">
        <FormField description="The Excel file to upload." label="File">
          <SpaceBetween direction="horizontal" size="m">
            <FileInput
              onChange={({ detail }) => setFile(detail.value ? detail.value[0] : null)}
              value={file ? [file] : []}
              multiple={false}
              accept="application/xlsx"
            >
              Choose file
            </FileInput>
            <Button
              variant="icon"
              onClick={() => setFile(null)}
              iconName="delete-marker"
              disabled={!file || upload.isPending}
            />
          </SpaceBetween>
        </FormField>
        {upload.error && <ErrorMessage loading={upload.isPending} error={upload.error} />}
      </SpaceBetween>
    </Modal>
  );
}
